/*=========================================================================================
  File Name: state.js
  Description: Restaurant Store Main File
  ----------------------------------------------------------------------------------------
  Item Name: Restaurant State Module
  Author: Tan Tran
==========================================================================================*/

import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
export default {
    namespaced: true,
    state : state,
    mutations : mutations,
    actions : actions,
    getters : getters
}